import { useAuthStore } from '../../../stores/authStore';
import { useSimulationStore } from '../../../stores/simulationStore';
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from '../select';

export function WorkspaceSelector() {
  const { user, setCurrentWorkspace } = useAuthStore();
  const { resetSimulation } = useSimulationStore();

  if (!user || !user?.workspace_profiles) return null;

  const currentWorkspace = user?.currentWorkspace;

  // Template workspaces are only shown to workspace admins
  const workspaces = user?.workspace_profiles?.filter(
    (w) => !w?.workspaces?.is_template || w?.role?.name === 'admin',
  );

  return (
    <Select
      value={currentWorkspace?.workspace_id}
      onValueChange={(workspaceId) => {
        const selected = workspaces?.find(
          (w) => w?.workspace_id === workspaceId,
        );
        if (selected) {
          resetSimulation();
          setCurrentWorkspace(selected);
        }
      }}
    >
      <SelectTrigger className="w-full bg-prompt-safecomwhite">
        <SelectValue placeholder="Select workspace" />
      </SelectTrigger>
      <SelectContent>
        {workspaces?.map((workspace) => (
          <SelectItem
            key={workspace?.workspace_id}
            value={workspace?.workspace_id}
          >
            <span className="flex items-center gap-2">
              {workspace?.workspaces?.name}{' '}
              {workspace?.workspaces?.is_template ? (
                <span className="rounded-sm bg-amber-100 px-1.5 py-0.5 text-xs font-medium text-amber-700">
                  Template
                </span>
              ) : workspace?.workspaces?.created_by === user?.id ? (
                '(owner)'
              ) : (
                `(${workspace?.role?.name})`
              )}
            </span>
          </SelectItem>
        ))}
      </SelectContent>
    </Select>
  );
}
